// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyProfile_profileContainer__c4Nw- {
  display: flex;
  flex-direction: column;
}
.MyProfile_imageContainer__Q4qC9 {
  background-color: #ebe6dd;
  height: 215px;
  margin-bottom: 64px;
  border-radius: 8px;
}

.MyProfile_imageUploadBtn__EKtL\\+,
.MyProfile_image__iThp0 {
  height: 215px;
  width: 180px;
  border-radius: 8px;
}

.MyProfile_imageUploadBtn__EKtL\\+ {
  margin: 32px 0px 0px 32px;
  border: 8px solid transparent;
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
}
.MyProfile_imageUploadBtn__EKtL\\+:hover {
  cursor: pointer;
}
.MyProfile_imageUploadBtn__EKtL\\+:hover,
.MyProfile_image__iThp0 {
  border: 8px solid #ffffff;
}
.MyProfile_fullNameRow__7KsPA {
  align-items: center;
  display: flex;
  justify-content: space-between;
  height: 52px;
}
.MyProfile_leftBox__Qrb-3 {
  display: flex;
  column-gap: 24px;
}
.MyProfile_nameText__T5n6E {
  color: #4d4d4d;
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.MyProfile_badge__7di\\+H {
  align-items: center;
  background-color: #87ad76;
  border-radius: 4px;
  display: flex;
  padding: 6px 12px;
}
.MyProfile_badgeText__zAl4e {
  color: #ffffff;
  cursor: default;
}
.MyProfile_groupBadgeText__LGB\\+t,
.MyProfile_badgeText__zAl4e {
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.MyProfile_rightBox__LPsDi,
.MyProfile_mobileRightBox__YaOSY {
  display: flex;
  column-gap: 10px;
}
.MyProfile_mobileRightBox__YaOSY {
  position: absolute;
  margin-top: 105rem;
  width: 90%;
}
.MyProfile_editButton__Bx1FK,
.MyProfile_imageUploadBtn__EKtL\\+,
.MyProfile_evidentationButton__oXIZ0,
.MyProfile_saveButton__UddJQ {
  display: flex;
  justify-content: center;
  align-items: center;
}
.MyProfile_editButton__Bx1FK {
  border: 1px solid #d1d9e2;
  border-radius: 4px;
  cursor: pointer;
  height: 52px;
  width: 200px;
}
.MyProfile_editButtonText__iZgrZ {
  margin: 0px;
}
.MyProfile_evidentationButton__oXIZ0 {
  background-color: #cb9c2d;
  border-radius: 4px;
  column-gap: 8px;
  cursor: pointer;
  height: 52px;
  width: 228px;
}

.MyProfile_cropButton__HdqVe {
  background-color: #cb9c2d;
  border-radius: 4px;
  column-gap: 8px;
  cursor: pointer;
  height: 52px;
  width: 228px;
  margin-right: 5px;
  margin-left: 5px;
  border: none;
  color: #ffffff;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.MyProfile_evidentationButtonText__P7bwf {
  color: #ffffff;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.MyProfile_buttonIcon__ffmyP {
  stroke: #ffffff;
}
.MyProfile_profileInfoContainer__m7C5n,
.MyProfile_profileInfoContainerMobile__SQE7z {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}
.MyProfile_profileInfoContainerMobile__SQE7z {
  flex-direction: column-reverse;
}
.MyProfile_rightProfileBox__Kl4n-,
.MyProfile_rightProfileBoxDisabled__Q386\\+ {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 48px;
  width: 228px;
}
.MyProfile_rightProfileBoxDisabled__Q386\\+ {
  opacity: 0.5;
}
.MyProfile_groupsMemberHeader__3HcHw {
  display: flex;
  column-gap: 8px;
  margin-bottom: 24px;
}
.MyProfile_groupsMemberTitle__mAX2\\+ {
  color: #4d4d4d;
  cursor: default;
  margin: 0px;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
}
.MyProfile_editButtonText__iZgrZ,
.MyProfile_addToGroupBtn__1yml8 {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  color: #5f6d7e;
}
.MyProfile_addToGroupBtn__1yml8 {
  width: 228px;
  height: 40px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  border: 1px solid #d1d9e2;
  background-color: white;
  text-align: left;
  display: flex;
  justify-content: center;
  margin-top: 10%;
}
.MyProfile_addToGroupBtn__1yml8:hover {
  cursor: pointer;
  transition: background-color 300ms;
}
.MyProfile_groupText__1lIad {
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: center;
  color: #5f6d7e;
  width: 80%;
  margin-top: 1%;
}
.MyProfile_groupsIcon__nqave {
  stroke: #4d4d4d;
}
.MyProfile_groupsBadges__Jqof7 {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.MyProfile_groupBadge__c1z57 {
  background-color: #f4f4f4;
  border-radius: 20px;
  padding: 8px;
}
.MyProfile_groupBadgeText__LGB\\+t {
  color: #4d4d4d;
  cursor: default;
}
.MyProfile_step__Fb9gH {
  font-family: Inter;
  font-size: 26px;
  font-weight: 600;
  color: #5f6d7e;
  padding: 20px 0 30px;
}
@media screen and (max-width: 900px) {
  .MyProfile_groupsMemberTitle__mAX2\\+ {
    font-size: 14px;
  }
  .MyProfile_rightProfileBox__Kl4n-,
  .MyProfile_rightProfileBoxDisabled__Q386\\+ {
    align-items: baseline;
    margin-top: 24px;
  }
  .MyProfile_mobileRightBox__YaOSY {
    align-items: center;
    justify-content: center;
  }
  .MyProfile_groupText__1lIad {
    text-align: left;
  }
  .MyProfile_nameText__T5n6E {
    font-size: 24px;
  }
  .MyProfile_badgeText__zAl4e {
    font-size: 12px;
  }
  .MyProfile_editButtonText__iZgrZ,
  .MyProfile_evidentationButtonText__P7bwf {
    font-size: 14px;
  }
  .MyProfile_buttonIcon__ffmyP {
    display: none;
  }
  .MyProfile_imageUploadBtn__EKtL\\+,
  .MyProfile_image__iThp0 {
    width: 150px;
    height: 110px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/myProfile/MyProfile.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;;EAEE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;EAIE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;;EAEE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE;IACE,eAAe;EACjB;EACA;;IAEE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;;IAEE,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":[".profileContainer {\n  display: flex;\n  flex-direction: column;\n}\n.imageContainer {\n  background-color: #ebe6dd;\n  height: 215px;\n  margin-bottom: 64px;\n  border-radius: 8px;\n}\n\n.imageUploadBtn,\n.image {\n  height: 215px;\n  width: 180px;\n  border-radius: 8px;\n}\n\n.imageUploadBtn {\n  margin: 32px 0px 0px 32px;\n  border: 8px solid transparent;\n  background-repeat: no-repeat;\n  background-size: cover;\n  box-sizing: border-box;\n}\n.imageUploadBtn:hover {\n  cursor: pointer;\n}\n.imageUploadBtn:hover,\n.image {\n  border: 8px solid #ffffff;\n}\n.fullNameRow {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  height: 52px;\n}\n.leftBox {\n  display: flex;\n  column-gap: 24px;\n}\n.nameText {\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.badge {\n  align-items: center;\n  background-color: #87ad76;\n  border-radius: 4px;\n  display: flex;\n  padding: 6px 12px;\n}\n.badgeText {\n  color: #ffffff;\n  cursor: default;\n}\n.groupBadgeText,\n.badgeText {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.rightBox,\n.mobileRightBox {\n  display: flex;\n  column-gap: 10px;\n}\n.mobileRightBox {\n  position: absolute;\n  margin-top: 105rem;\n  width: 90%;\n}\n.editButton,\n.imageUploadBtn,\n.evidentationButton,\n.saveButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.editButton {\n  border: 1px solid #d1d9e2;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 52px;\n  width: 200px;\n}\n.editButtonText {\n  margin: 0px;\n}\n.evidentationButton {\n  background-color: #cb9c2d;\n  border-radius: 4px;\n  column-gap: 8px;\n  cursor: pointer;\n  height: 52px;\n  width: 228px;\n}\n\n.cropButton {\n  background-color: #cb9c2d;\n  border-radius: 4px;\n  column-gap: 8px;\n  cursor: pointer;\n  height: 52px;\n  width: 228px;\n  margin-right: 5px;\n  margin-left: 5px;\n  border: none;\n  color: #ffffff;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.evidentationButtonText {\n  color: #ffffff;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.buttonIcon {\n  stroke: #ffffff;\n}\n.profileInfoContainer,\n.profileInfoContainerMobile {\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n}\n.profileInfoContainerMobile {\n  flex-direction: column-reverse;\n}\n.rightProfileBox,\n.rightProfileBoxDisabled {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin-top: 48px;\n  width: 228px;\n}\n.rightProfileBoxDisabled {\n  opacity: 0.5;\n}\n.groupsMemberHeader {\n  display: flex;\n  column-gap: 8px;\n  margin-bottom: 24px;\n}\n.groupsMemberTitle {\n  color: #4d4d4d;\n  cursor: default;\n  margin: 0px;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n}\n.editButtonText,\n.addToGroupBtn {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  color: #5f6d7e;\n}\n.addToGroupBtn {\n  width: 228px;\n  height: 40px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #d1d9e2;\n  background-color: white;\n  text-align: left;\n  display: flex;\n  justify-content: center;\n  margin-top: 10%;\n}\n.addToGroupBtn:hover {\n  cursor: pointer;\n  transition: background-color 300ms;\n}\n.groupText {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: #5f6d7e;\n  width: 80%;\n  margin-top: 1%;\n}\n.groupsIcon {\n  stroke: #4d4d4d;\n}\n.groupsBadges {\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n}\n.groupBadge {\n  background-color: #f4f4f4;\n  border-radius: 20px;\n  padding: 8px;\n}\n.groupBadgeText {\n  color: #4d4d4d;\n  cursor: default;\n}\n.step {\n  font-family: Inter;\n  font-size: 26px;\n  font-weight: 600;\n  color: #5f6d7e;\n  padding: 20px 0 30px;\n}\n@media screen and (max-width: 900px) {\n  .groupsMemberTitle {\n    font-size: 14px;\n  }\n  .rightProfileBox,\n  .rightProfileBoxDisabled {\n    align-items: baseline;\n    margin-top: 24px;\n  }\n  .mobileRightBox {\n    align-items: center;\n    justify-content: center;\n  }\n  .groupText {\n    text-align: left;\n  }\n  .nameText {\n    font-size: 24px;\n  }\n  .badgeText {\n    font-size: 12px;\n  }\n  .editButtonText,\n  .evidentationButtonText {\n    font-size: 14px;\n  }\n  .buttonIcon {\n    display: none;\n  }\n  .imageUploadBtn,\n  .image {\n    width: 150px;\n    height: 110px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileContainer": `MyProfile_profileContainer__c4Nw-`,
	"imageContainer": `MyProfile_imageContainer__Q4qC9`,
	"imageUploadBtn": `MyProfile_imageUploadBtn__EKtL+`,
	"image": `MyProfile_image__iThp0`,
	"fullNameRow": `MyProfile_fullNameRow__7KsPA`,
	"leftBox": `MyProfile_leftBox__Qrb-3`,
	"nameText": `MyProfile_nameText__T5n6E`,
	"badge": `MyProfile_badge__7di+H`,
	"badgeText": `MyProfile_badgeText__zAl4e`,
	"groupBadgeText": `MyProfile_groupBadgeText__LGB+t`,
	"rightBox": `MyProfile_rightBox__LPsDi`,
	"mobileRightBox": `MyProfile_mobileRightBox__YaOSY`,
	"editButton": `MyProfile_editButton__Bx1FK`,
	"evidentationButton": `MyProfile_evidentationButton__oXIZ0`,
	"saveButton": `MyProfile_saveButton__UddJQ`,
	"editButtonText": `MyProfile_editButtonText__iZgrZ`,
	"cropButton": `MyProfile_cropButton__HdqVe`,
	"evidentationButtonText": `MyProfile_evidentationButtonText__P7bwf`,
	"buttonIcon": `MyProfile_buttonIcon__ffmyP`,
	"profileInfoContainer": `MyProfile_profileInfoContainer__m7C5n`,
	"profileInfoContainerMobile": `MyProfile_profileInfoContainerMobile__SQE7z`,
	"rightProfileBox": `MyProfile_rightProfileBox__Kl4n-`,
	"rightProfileBoxDisabled": `MyProfile_rightProfileBoxDisabled__Q386+`,
	"groupsMemberHeader": `MyProfile_groupsMemberHeader__3HcHw`,
	"groupsMemberTitle": `MyProfile_groupsMemberTitle__mAX2+`,
	"addToGroupBtn": `MyProfile_addToGroupBtn__1yml8`,
	"groupText": `MyProfile_groupText__1lIad`,
	"groupsIcon": `MyProfile_groupsIcon__nqave`,
	"groupsBadges": `MyProfile_groupsBadges__Jqof7`,
	"groupBadge": `MyProfile_groupBadge__c1z57`,
	"step": `MyProfile_step__Fb9gH`
};
export default ___CSS_LOADER_EXPORT___;
